import { Grid, Typography } from '@mui/material';
import { Event } from '../../model/event';
import TitleValueField from '../commons/TitleValueField';

interface IProps {
  eventDetails?: Event;
}

function EventDetailsGrid({ eventDetails }: IProps) {
  const address = eventDetails?.address;
  const eventId = { title: 'EVENT ID', value: eventDetails?.eventId };
  const eventType = { title: 'EVENT TYPE', value: eventDetails?.eventType };
  const groupImageExpected = {
    title: 'GROUP IMAGES',
    value: eventDetails?.groupPicturesExpected ? 'Y' : 'N',
  };
  const apoId = { title: 'APO ID', value: eventDetails?.apoId };
  const status = { title: 'STATUS', value: eventDetails?.status?.toString() };
  const accountAddress = { title: 'ACCOUNT ADDRESS' };
  const subProgram = { title: 'SUBPROGRAM', value: eventDetails?.subProgramName };

  if (eventDetails?.apoCategoryType === 'PhotoDay') {
    eventType.value += ' - PHOTO DAY'
  }

  return (
    <div>
      <Grid
        container
        p={2}
        textAlign={'left'}
        justifyContent={'flex-start'}
        rowGap={2}
      >
        <Grid item xs={12} md={6} lg={4}>
          <TitleValueField {...eventType} />
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <TitleValueField {...eventId} />
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <TitleValueField {...status} />
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <TitleValueField {...apoId} />
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <TitleValueField {...accountAddress} />
          <Typography variant='body1'>
            {address ? (
              <>
                {address.address1}
                {address.address2 && address.address2.trim() ? (
                  <>
                    <br />
                    {address.address2}
                  </>
                ) : (
                  <></>
                )}
                <br />
                {address.city}, {address.state} {address.zipCode}
              </>
            ) : (
              <></>
            )}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <TitleValueField {...groupImageExpected} />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <TitleValueField {...subProgram} />
        </Grid>
      </Grid>
    </div>
  );
}

export default EventDetailsGrid;
